import { Flex } from 'antd';
import { Text, Title } from 'components/mvp-typography';
import { Redirect, useLocation } from 'react-router-dom';
import { IntegrationRoutes } from 'routes';

export function PilotAlreadyJoinedState() {
  const location = useLocation();
  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap={16}
      style={{ height: '100%' }}
    >
      <Title>You are already in the Pilot.</Title>
      <Text>Redirecting to the test-taker form in 3 seconds...</Text>
      <Redirect
        to={{
          pathname: IntegrationRoutes.IMPACT_PATIENT_IMPORT,
          search: location.search
        }}
        push
      />
    </Flex>
  );
}
